module.exports = __webpack_public_path__ + "static/media/newProfile.d72fb147.jpeg";